module.exports = __webpack_public_path__ + "img/master-car.a87f266d.png";